import { mediaApi } from "api/instances";
import { IAttachedGalleryFile, Image } from "modules/gallery";

/*
* Converts a path to an svg to the contents of the file.
* Example of an image path would be: '/images/icons/sample_svg.svg'
*/
export const convertSVGToString = async (path: string): Promise<string> => {
    const svgFile = await fetch(path);
    const svgContent = await svgFile.text();
    return svgContent;
}

export const getAttachmentFromFile = async (file: Image): Promise<IAttachedGalleryFile> => {
    if (!file) return Promise.reject();

    let attachment = {
        ospreyId: file.id,
        fileName: file.name,
        blobId: file.blobId,
        fileUrl: file.url,
        fileType: "image",
        originalFileUrl: file.url,
    } as IAttachedGalleryFile;

    if (file.videoId) {
        const videoUrl = await getVideoUrl(file.videoId);

        attachment.fileType = "video";
        attachment.ospreyId = file.videoId;
        attachment.fileUrl = videoUrl; //fetch later
    }

    return attachment;
};

export const getVideoUrl = async (videoId: string): Promise<string> => {
    try {
        return await mediaApi.GetVideoUrl(videoId);
    }
    catch (error) {
        throw error;
    }
}